import { render, staticRenderFns } from "./ClientCell.vue?vue&type=template&id=3cfdd066&"
import script from "./ClientCell.vue?vue&type=script&lang=js&"
export * from "./ClientCell.vue?vue&type=script&lang=js&"
import style0 from "./ClientCell.vue?vue&type=style&index=0&id=3cfdd066&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports